import React from "react";

/**
 * EmptyState — consistent empty / placeholder block.
 *
 *  - icon: lucide icon component
 *  - title: short uppercase title
 *  - description: longer helper text
 *  - action: optional ReactNode (button)
 *  - dense: smaller padding
 */
export function EmptyState({ icon: Icon, title, description, action, dense = false, className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col items-center text-center ${dense ? "py-6 px-4" : "py-10 px-6"} ${className}`}
    >
      {Icon && (
        <div className="w-12 h-12 border border-dashed border-zinc-300 flex items-center justify-center mb-3 text-zinc-400">
          <Icon size={20} />
        </div>
      )}
      {title && <div className="font-display font-bold text-base tracking-tight">{title}</div>}
      {description && <div className="text-xs text-zinc-500 mt-1 max-w-md">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
